<template>
    <div>
        <!-- SELECT FISCAL YEARS -->
        <fiscal-years-select
            :fiscalYears="form.fiscalyears"
            @updateFiscalYears="updateFiscalYears"
            @loaded="$emit('updateLoading', { loading: false })"
        />
    </div>
</template>

<script>
import SettingsFormMixin from './SettingsFormMixin.js';
import FiscalYearsSelect from './FiscalYearsSelect.vue';

export default {
    components: {
        'fiscal-years-select': FiscalYearsSelect,
    },
    mixins: [SettingsFormMixin],
    created() {
        this.$emit('updateLoading', { loading: true });
    },
    mounted() {
        this.$emit('set-rules', this.agendaRules);
    },
    methods: {
        close() {
            this.$emit('close-form');
        },
        updateFiscalYears(data) {
            this.form.fiscalyears = data;
        },
    },
};
</script>
